import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAlertOutline16 = function SvgAlertOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.016 2.24.002.002 6.23 10.518c.314.542.302.96.14 1.239-.163.28-.524.501-1.152.501H1.764c-.628 0-.99-.221-1.152-.502-.162-.279-.174-.697.14-1.236v-.001L6.984 2.24l.002-.003C7.297 1.702 7.67 1.5 8 1.5c.329 0 .703.202 1.016.74z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32 10.257h.1V4.082h-.84v6.175h.74zM8 11.317a.704.704 0 0 0-.705.703.704.704 0 0 0 1.41 0A.704.704 0 0 0 8 11.318z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })));
};

var AlertOutline16Svg = SvgAlertOutline16;

export { AlertOutline16Svg as default };
//# sourceMappingURL=AlertOutline16.svg.js.map
